module.exports = __webpack_public_path__ + "img/logo.d38fd3be.png";